import { specialFlowResponseSchema, specialListResponseSchema, specialSubmitPayloadSchema, specialValidationErrorSchema, } from "./specialsSchema";
var buildParseFailure = function (description) { return ({
    success: false,
    error: description,
}); };
export var parseSpecialListResponse = function (payload) {
    var result = specialListResponseSchema.safeParse(payload);
    if (!result.success) {
        return buildParseFailure("Unable to load specials because the response format was invalid.");
    }
    return {
        success: true,
        data: result.data,
    };
};
export var parseSpecialFlowResponse = function (payload) {
    var result = specialFlowResponseSchema.safeParse(payload);
    if (!result.success) {
        return buildParseFailure("Unable to load this special because the response format was invalid.");
    }
    return {
        success: true,
        data: result.data,
    };
};
export var parseSpecialSubmitPayload = function (payload) {
    var result = specialSubmitPayloadSchema.safeParse(payload);
    if (!result.success) {
        return buildParseFailure("Unable to add this special because the selected items were invalid.");
    }
    return {
        success: true,
        data: result.data,
    };
};
export var parseSpecialValidationError = function (payload) {
    var result = specialValidationErrorSchema.safeParse(payload);
    if (!result.success) {
        return {
            message: "Unable to add this special. Please review your selections and try again.",
        };
    }
    return result.data;
};
